module.exports = __webpack_public_path__ + "static/media/warning.4ba1d198.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/alerts/warning.svg
// module id = 309
// module chunks = 0